
<template>
  <div class="modal-bg" v-if="flag">
    <div class="modal" :style="'width:'+width+'px'">
      <header>
        <slot name="title"></slot>
        <Icon type="ios-close" class="icon-close" color="#fff" @click="close" />
        <!-- <i class="iconfont " @click="close"></i> -->
      </header>
      <section>
        <slot name="content"></slot>
      </section>
      <footer>
        <Button type="primary" size="small" ghost @click="close">取消</Button>
        <Button type="primary" size="small" @click="confirm">确认</Button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "YnModal",
  props: ["width", "flag"],
  methods: {
    close() {
      this.$emit("on-close");
    },
    confirm() {
      this.$emit("on-confirm");
    }
  }
};

/** 
 * 弹窗组件使用说名 
 * 
 * 1、组件中引用 
 *  import YnModal from './../components/YnModal.vue'
 *  components:{YnModal},
 * 2、页面中使用
 *  
    *  <yn-modal width="300" :flag="flag" @on-close="close" @on-confirm="confirm">
        <span slot='title'>编辑</span>
        <Form slot="content" ref="formInline" :model="formInline" :rules="ruleInline">
        <FormItem prop="user">
            <Input type="text" v-model="formInline.user" placeholder="账号">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
        </FormItem>
        <FormItem prop="password">
            <Input type="password" v-model="formInline.password" placeholder="密码">
            <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </Input>
        </FormItem>
        </Form>
    </yn-modal>

    属性：
    width：模态框的宽度
    flag ：模态框是否隐藏

    内容：
    <slot name="title"></slot> 模态框的标题
    <slot name="content"></slot> 模态框的主体显示内容

    方法：
    on-close 关闭模态框时 触发
    on-confirm 点击模态框按钮时 触发
 * 
*/
</script>




// WEBPACK FOOTER //
// src/components/YnModal.vue